import { useMemo } from 'react';
import useUser from '@alltrails/context/hooks/useUser';
import { useExperiments, useExposureEvent } from '@alltrails/experiments';

const useNaturalLanguageSearchExperiment = () => {
  const user = useUser();
  const experiments = useExperiments();
  const sendExposure = useExposureEvent('web-ai-natural-language-search');

  const isNaturalLanguageExperimentEligible = Boolean(user);
  const onInputFocus = useMemo(
    () =>
      isNaturalLanguageExperimentEligible
        ? () => {
            sendExposure();
          }
        : undefined,
    [isNaturalLanguageExperimentEligible, sendExposure]
  );
  const isNaturalLanguageSearchEnabled = isNaturalLanguageExperimentEligible && experiments['web-ai-natural-language-search']?.value === 'treatment';

  return useMemo(
    () => ({
      isNaturalLanguageSearchEnabled,
      onInputFocus
    }),
    [isNaturalLanguageSearchEnabled, onInputFocus]
  );
};

export default useNaturalLanguageSearchExperiment;
